import React, {useEffect, useRef} from "react";
import styled from "styled-components";
import {useDispatch} from "react-redux";
import {CLEAR_REQUEST} from "../message/actions/actionTypes";


const AlertMessage = ({title, status}) => {
    const btn = useRef()
    const alert = useRef()

    const dispatch = useDispatch()
    useEffect(() => {
        btn.current.addEventListener('click', () => {
            alert.current.classList.toggle('slide-to-left')
        })
    }, [])

    useEffect(() => {

        return () => {
            dispatch({type:CLEAR_REQUEST})
        }
    }, [dispatch])

    const getBackgroundColorByStatus = (status) => {
        if (status === 'alert') {
            return 'rgba(233, 64, 91, 1)'
        } else if (status === 'success') {
            return 'rgba(82, 215, 131, 1)'
        }
    }

    const alertStyles = {
        background: getBackgroundColorByStatus(status)
    }

    return (
        <Alert ref={alert} style={alertStyles}>
            <button ref={btn}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="20px"
                    viewBox="0 0 24 24"
                    width="24px"
                    fill="#212529">
                    <path
                        d="M0 0h24v24H0V0z"
                        fill="none"
                        opacity=".87"/>
                    <path
                        d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm4.3 14.3c-.39.39-1.02.39-1.41 0L12 13.41 9.11 16.3c-.39.39-1.02.39-1.41 0-.39-.39-.39-1.02 0-1.41L10.59 12 7.7 9.11c-.39-.39-.39-1.02 0-1.41.39-.39 1.02-.39 1.41 0L12 10.59l2.89-2.89c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41L13.41 12l2.89 2.89c.38.38.38 1.02 0 1.41z"/>
                </svg>
            </button>
            <p> {title} </p>
        </Alert>
    )
}
const Alert = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: center;
  position: absolute;
  inset: 0;
  width: 15em;
  height: 3em;
  font-weight: 700;
  animation: alert 0.85s ease-out;
  transition: all 0.5s ease-out;
  border-radius: 0 10px 10px 0;

  p {
    flex-grow: 1;
    text-align: center;
  }


  button {
    height: 100%;
    display: flex;
    align-items: flex-start;
    border: none;
    background: transparent;
    cursor: pointer;

    &:hover {
      svg {
        fill: rgba(33, 37, 41, 0.8);
      }
    }

  }

  @keyframes alert {
    0% {
      opacity: 0;
      transform: translateX(-100%);
    }
    100% {
      opacity: 1;
      transform: translateX(0);
    }
    0% {
      opacity: 0;
      transform: translateX(-100%);
    }
  }
`


export default AlertMessage